import * as XLSX from 'xlsx';

/**
 * Converts a list of objects into an Excel file and triggers download.
 * @param {Array} data List of objects to be exported
 */
export function exportToExcel(data) {
  if (!data || !data.length) {
    console.error('No data available for export.');
    return;
  }

  // Define a map of user-friendly headers
  const headersMap = {
    title: 'Title',
    firstName: 'First Name',
    lastName: 'Last Name',
    knownAs: 'Known As',
    email: 'Email',
    website: 'Website',
    personId: 'Person ID',
    consultant: 'Consultant',
    regDate: 'Registration Date',
    source: 'Source',
    statusDate: 'Status Date',
    status: 'Status',
    createdAt: 'Created At',
    // updatedAt: 'Updated At',
    marketing: 'Marketing',
    qualifications: 'Qualifications',
    skills: 'Skills',
    jobTitles: 'Job Titles',
    industrySector: 'Industry Sector',
    hoursPerWeek: 'Hours Per Week',
    vehicleLicense: 'Vehicle Registration Number',
    rate: 'Rate',
    availDate: 'Available Date',
    niNo: 'National Insurance No.',
    tempDetails: 'Temporary Details',
    twelveWeekAverage: '12-Week Average',
    weeksEmployed: 'Weeks Employed',
    payrollNo: 'Payroll No.',
    testimonial: 'Testimonial',
    penPicture: 'Pen Picture',
    maritalStatus: 'Marital Status',
    visaExpiry: 'Visa Expiry',
    visaType: 'Visa Type',
    nationality: 'Nationality',
    age: 'Age',
    dateOfBirth: 'Date of Birth',
    awrType: 'AWR Type',
    rateType: 'Rate Type',
    address: 'Address',
    contact: 'Contact Details'
  };

  // Prepare data for export
  const exportData = data.map(item => {
    const formattedItem = {};
    Object.keys(item).forEach(key => {
      if (key === '_id' || key === 'gdpr') return; // Skip these fields

      if (headersMap[key]) {
        const value = item[key];

        // Format dates to a readable format
        if (value && new Date(value).toString() !== 'Invalid Date' && typeof value === 'string' && value.includes('T')) {
          formattedItem[headersMap[key]] = new Date(value).toLocaleDateString();
        } else if (key === 'address' && Array.isArray(value)) {
          formattedItem[headersMap[key]] = value.map(addr => {
            return `${addr.addressType}: ${addr.addressLine1}, ${addr.addressLine2}, ${addr.town}, ${addr.county}, ${addr.country}, ${addr.postcode}`;
          }).join(' | ');
        } else if (key === 'contact' && typeof value === 'object') {
          formattedItem[headersMap[key]] = value.phoneType ? `${value.phoneType}: ${value.phoneNumber}` : '';
        } else if (key === 'tempDetails' && typeof value === 'object') {
          formattedItem[headersMap[key]] = `Start: ${value.tempStartDate ? new Date(value.tempStartDate).toLocaleDateString() : 'N/A'}, Finish: ${value.tempFinishDate ? new Date(value.tempFinishDate).toLocaleDateString() : 'N/A'}, Type: ${value.type}`;
        } else {
          formattedItem[headersMap[key]] = value;
        }
      }
    });

    return formattedItem;
  });

  // Create worksheet and workbook
  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Exported Candidate Data');
  XLSX.writeFile(workbook, 'candidates.xlsx');
}
